import { useState, useEffect, useCallback } from "react";
import { apiService } from "../api/services/apiService";
import type { SupportCase } from "../types";
import { useIsCsr } from "./useIsCsr";
import { useIsProductManager } from "./useIsProductManager";

export const useSupportCases = () => {
  const isCsr = useIsCsr();
  const isPm = useIsProductManager();
  const showAgentQueue = isCsr || isPm;

  const [myCases, setMyCases] = useState<SupportCase[]>([]);
  const [agentCases, setAgentCases] = useState<SupportCase[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSupportCases = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const mine = await apiService.getMySupportCases();
      setMyCases(mine);
      if (showAgentQueue) {
        const agent = await apiService.getAgentSupportCases();
        setAgentCases(agent);
      } else {
        setAgentCases([]);
      }
    } catch (err: unknown) {
      console.error(err);
      setError(
        err instanceof Error ? err.message : "Failed to fetch support cases",
      );
    } finally {
      setLoading(false);
    }
  }, [showAgentQueue]);

  useEffect(() => {
    fetchSupportCases();
  }, [fetchSupportCases]);

  return {
    myCases,
    agentCases,
    showAgentQueue,
    isCsr,
    isPm,
    loading,
    error,
    refresh: fetchSupportCases,
  };
};
